<template>
    <div>

        <div>

            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">
                宿舍房间管理-床号
                <el-button style="float: right; height: 40px; margin-top: -10px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="Return('home')">返回</el-button>
            </div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px;">

                    <el-row style="padding-left: 46px; padding-top: 40px;">
                        <el-col :span="4">
                            <span>床号</span>
                            <el-input v-model="input" placeholder="请输入床号" style="width: 75%; margin-left: 10px;">
                            </el-input>
                        </el-col>
                        <el-col :span="4">
                            <el-input v-model="input" placeholder="请输入查询内容" style="width: 75%; margin-left: 10px;">
                            </el-input>
                        </el-col>
                        <el-col :span="8">
                            <div style="margin-left: -10px;">
                                <el-button
                                    style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                    查询</el-button>
                                <el-button
                                    style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                    删除</el-button>
                                <el-button style="width: 85px; border: 1px solid #006E4B; color: #006E4B;" @click="AddFrom">新增</el-button>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row style="margin: 0px 2%; margin-top: 10px;">
                        <el-row>
                            <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                                :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" height="595"
                                tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55">
                                </el-table-column>
                                <el-table-column align="center" label="序号">
                                    <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                                </el-table-column>
                                <el-table-column prop="bankuai" align="center" label="床号"></el-table-column>
                            </el-table>
                        </el-row>
                        <el-row style="margin-top: 10px; text-align: center;">
                            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                                layout=" prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </el-row>
                    </el-row>
                </div>
            </el-row>
        </div>

        <div>
            <el-dialog title="添加床号" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" :center="true">
                <add ref="add"></add>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import add from './ChGl_add.vue';

    import axios from "axios";
    export default {
        components: {
            add: add,
        },
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [{
                    fgs: "123",
                    csgs: "123",
                    bankuai: "123",
                    xiangmu: "123",
                    gangwei: "123",
                }],
                
                //页面相关
                dialogVisible: false,
            };
        },
        methods: {
            Return(e){
                if(e === 'edit'){
                    this.eidtRedirection = false;
                }else if(e === 'add'){
                    this.dialogVisible = false;
                }else{
                    this.$parent.Return('edit');
                }
            },
            AddFrom(){
                this.dialogVisible = true;
            }
        },
        created() {

        }
    }
</script>

<style scoped="scoped">
</style>



// WEBPACK FOOTER //
// ChGl.vue?4bc60188